// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"aws":"e088a7b2","lsc":"66affab6","others":"bd8040ba"}[chunkId] + ".chunk.js";
};